module.exports = __webpack_public_path__ + "static/media/Hassan_bin_sabit_high_school_logo.145a243e.png";